import { Injectable } from '@angular/core';

import { DragHandlerBase } from './drag-handler-base';
import { mountableObjectIsWithinWallArea } from '../../../../services/wall/utils/mountable-object-is-within-wall-area';

declare const THREE: any;

// Keeps a standalone wall-mounted object (e.g. Trellis) on its wall face while
// dragging. Unlike KeepAwningOnWallAreaHandler it has no awning-group logic —
// bounds are taken from the dragged object's own bounding box.
class KeepMountableOnWallAreaHandler extends DragHandlerBase {
  constructor(nextHandler) {
    super(nextHandler);
  }

  move(e, transformation) {
    const draggedObject = e.draggedObject;
    const wall = draggedObject.parent;

    if (wall) {
      const box = new THREE.Box3().setFromObject(draggedObject);
      const size = box.getSize(new THREE.Vector3());
      const currentCenter = box.getCenter(new THREE.Vector3());
      const worldPosition = draggedObject.getWorldPosition(new THREE.Vector3());
      const newCenter = transformation.position
        .clone()
        .sub(worldPosition)
        .add(currentCenter);

      const withinWall = mountableObjectIsWithinWallArea(
        wall,
        { width: size.z, length: size.x, height: size.y },
        newCenter,
        draggedObject.rotation
      );

      if (!withinWall) {
        transformation.position = worldPosition;
      }
    }

    super.move(e, transformation);
  }
}

@Injectable()
export class KeepMountableOnWallBoundsHandlerFactory {
  create(nextHandler?: DragHandlerBase): DragHandlerBase {
    return new KeepMountableOnWallAreaHandler(nextHandler);
  }
}



// WEBPACK FOOTER //
// ./src/app/Component(2D and 3D)/3D/Drag/Handler/keep-mountable-on-wall-area-handler.ts